import type React from 'react';
import { Page as Component } from '~/components/specifics/admin/vendor_companies/Page';

export const Page: React.FC = () => <Component />;
